import { render, staticRenderFns } from "./UpdateSettings.vue?vue&type=template&id=1343e07d"
import script from "./UpdateSettings.vue?vue&type=script&lang=js"
export * from "./UpdateSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports